import React from 'react'

const Movies = () => {
  return (
    <div>Movie들을 나열, 왼쪽에 sort, filter</div>
  )
}

export default Movies